import { render, staticRenderFns } from "./Side_navigation.vue?vue&type=template&id=459f5b3c&scoped=true&"
import script from "./Side_navigation.vue?vue&type=script&lang=js&"
export * from "./Side_navigation.vue?vue&type=script&lang=js&"
import style0 from "./Side_navigation.vue?vue&type=style&index=0&id=459f5b3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459f5b3c",
  null
  
)

export default component.exports